import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { SentEmail } from '../../../../app/interfaces/sent-emails/sent-email';

@Component({
  selector: 'fury-email-viewer-dialog',
  templateUrl: './email-viewer-dialog.component.html',
  styleUrls: ['./email-viewer-dialog.component.scss'],
})

export class EmailViewerDialogComponent implements OnInit {

  public content: SafeHtml = null;

  constructor(@Inject(MAT_DIALOG_DATA) public data: SentEmail,
              public sanitizer: DomSanitizer,
  ) {
  }

  ngOnInit(): void {
  }
}
